import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'

import {
  useCreateBlockingDomainMutation,
  useUpdateBlockingDomainByIdMutation
} from '../../redux/apis/blockingDomainsManagement/bDDomainsApiSlice'
import TextArea from 'antd/es/input/TextArea'

const EditCreateBlockingDomain = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateBlockingDomainByIdMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateBlockingDomainMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      domains: '',
      domain: record?.domain,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      domains:
        state === 'create'
          ? Yup.string().required('Please Enter Domains')
          : Yup.string().nullable(),
      domain:
        state === 'edit'
          ? Yup.string().required('Please Enter Domain')
          : Yup.string().nullable()
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: {
              domain: values.domain,
              last_updated_by: values.last_updated_by
            },
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          const urls = values.domains
            .split('\n')
            .map(url => url.trim())
            .filter(Boolean)
          await addService({
            domains: urls,
            last_updated_by: values.last_updated_by
          }).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Blocking Domains created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Blocking Domain updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={
        state === 'edit' ? `Edit Blocking Domain` : 'Create Blocking Domains'
      }
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      {state === 'create' && (
        <div className=' mb-3 flex-1 '>
          <label className="form-label">URLs (separated by new lines)</label>
          <TextArea
            type='text'
            name='domains'
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.domains}
            placeholder='Enter domains separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
            rows={15}
          />
          {validation.touched.domains && validation.errors.domains ? (
            <p className='text-danger'>{validation.errors.domains}</p>
          ) : null}
        </div>
      )}

      {state === 'edit' && (
        <div className=' mb-3'>
          <label className="form-label">Domain</label>
          <Input
            type='text'
            name='domain'
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.domain}
          />
          {validation.touched.domain && validation.errors.domain ? (
            <p className='text-danger'>{validation.errors.domain}</p>
          ) : null}
        </div>
      )}
    </Modal>
  )
}

export default EditCreateBlockingDomain
